import React from 'react';
import { Tooltip } from '@planne-software/uni/Tooltip';
import { IconHelp } from '@tabler/icons-react';
import type { LegendLabels } from '@src/domains/scheduling';
import {
  LegendDisclaimerIconWrap,
  LegendDisclaimerRow,
  LegendDisclaimerText,
  LegendItem,
  LegendItemsRow,
  LegendLabel,
  LegendRoot,
  LegendSwatch,
  LegendSwatchTodayDot,
} from './styles';

type CustomLegendProps = {
  labels: LegendLabels;
  showPriceDisclaimer: boolean;
};

const CustomLegend = (props: CustomLegendProps) => {
  const { labels, showPriceDisclaimer } = props;

  return (
    <LegendRoot>
      <LegendItemsRow>
        <LegendItem>
          <LegendLabel>{labels.available}</LegendLabel>
          <LegendSwatch variant='available' />
        </LegendItem>
        <LegendItem>
          <LegendLabel>{labels.current}</LegendLabel>
          <LegendSwatch variant='today'>
            <LegendSwatchTodayDot />
          </LegendSwatch>
        </LegendItem>
        <LegendItem>
          <LegendLabel>{labels.unavailable}</LegendLabel>
          <LegendSwatch variant='unavailable' />
        </LegendItem>
      </LegendItemsRow>
      {showPriceDisclaimer && labels.priceDisclaimer ? (
        <LegendDisclaimerRow>
          <LegendDisclaimerText>{labels.priceDisclaimer}</LegendDisclaimerText>
          {labels.priceTooltip ? (
            <Tooltip label={labels.priceTooltip}>
              <LegendDisclaimerIconWrap interactive>
                <IconHelp size={20} />
              </LegendDisclaimerIconWrap>
            </Tooltip>
          ) : (
            <LegendDisclaimerIconWrap>
              <IconHelp size={20} />
            </LegendDisclaimerIconWrap>
          )}
        </LegendDisclaimerRow>
      ) : null}
    </LegendRoot>
  );
};

export default CustomLegend;
